"use client";
import React from 'react';
import SharedImageLightbox from '@/components/media/ImageLightbox';

export default function ImageLightbox({ src, open, onClose }: { src?: string | null; open: boolean; onClose: () => void }) {
  return (
    <SharedImageLightbox src={src || undefined} alt={src ? 'Attachment' : undefined} open={open} onClose={onClose} />
  );
}
